/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Photo_ShootInputs */

const cs_enum_photo_shoot = /** @type {(inputs: Enum_Photo_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focení`)
};

const en_enum_photo_shoot = /** @type {(inputs: Enum_Photo_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo shoot`)
};

/**
* | output |
* | --- |
* | "Photo shoot" |
*
* @param {Enum_Photo_ShootInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_photo_shoot = /** @type {((inputs?: Enum_Photo_ShootInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Photo_ShootInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_photo_shoot(inputs)
	return cs_enum_photo_shoot(inputs)
});